<template>
  <div>
    <PostalCodeDetail
      ref="postalCodeDetail"
      type="edit"
      :submitting="submitting"
      :values="data"
      @submit="submit"
    />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper';
import { mapGetters } from 'vuex';
import PostalCodeDetail from '@/views/pages/postal_codes/PostalCodeDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    PostalCodeDetail
  },
  mixins: [helper],

  computed: {
    ...mapGetters({
      countries: 'app/countries'
    })
  },

  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },

  async created() {
    const postalCodeId = this.$route.params.id;
    this.id = postalCodeId;

    await this.$store.dispatch('app/getCountries');
    await this.getPostalCodeDetail(postalCodeId);
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .editPostalCode(this.id, {
          ...data
        })
        .then(response => {
          if (response.status) {
            this.showSuccessMessage(`${response.message}`);
            this.$router.push('/postal_codes');
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getPostalCodeDetail(postalCodeId) {
      this.submitting = true;
      useService
        .getPostalCode(postalCodeId)
        .then(response => {
          const {
            country_code,
            zipcode,
            place,
            state,
            state_code,
            province,
            province_code,
            community,
            community_code
          } = response.data;

          this.data = {
            country_code,
            zipcode,
            place,
            state,
            state_code,
            province,
            province_code,
            community,
            community_code,
            province_id: ''
          };

          let countryItem = null;
          if (country_code) {
            countryItem = this.countries.find(x => x.iso2 === country_code);

            if (countryItem) {
              this.data.country = countryItem.value;
              this.$refs.postalCodeDetail.setChangeToChange(countryItem.value);
            }
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
